import { FC } from 'react'
import { BsSortNumericDown, BsSortNumericDownAlt } from 'react-icons/bs'

type Props = {
  isAsc: boolean
}
const NumberAscDescSort: FC<Props> = (props) => {
  const { isAsc } = props

  return (
    <>
      {isAsc ? (
        <>
          <span>昇順</span>
          <BsSortNumericDown size={'1rem'} />
        </>
      ) : (
        <>
          <span>降順</span>
          <BsSortNumericDownAlt size={'1rem'} />
        </>
      )}
    </>
  )
}

export default NumberAscDescSort
